import Vue from 'vue'
import { AUTH_REQUEST, AUTH_LOGOUT, AUTH_SUCCESS, AUTH_ERROR, AUTH_REFRESH } from '../variables'

export default {
	state: {
		token: localStorage.getItem('user-token') || '',
		refreshToken: localStorage.getItem('refresh-token') || '',
		tokenExpiration: localStorage.getItem('token-expiration') || '',
		_id: localStorage.getItem('token-id') || '',
		user: localStorage.getItem('user') || '',
		status: ''
	},
	getters: {
		hasRefreshToken: state => !!state.refreshToken,
		isAuthenticated: state => !!state.token,
		authStatus: state => state.status,
		userId: state => state.user
	},
	actions: {
		[AUTH_REQUEST]: ({ commit, dispatch }, user) => {
			return new Promise((resolve, reject) => {
				commit(AUTH_REQUEST)
				Vue.axios.defaults.headers.common['Authorization'] = 'Basic ' +
					window.btoa(user.mail + ':' + user.password)
				Vue.axios.post('authenticate/pro', { stayConnected: user.stayConnected })
					.then(resp => {
						commit(AUTH_SUCCESS, resp.data)

						Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.token

						resolve(resp)
					})
					.catch(err => {
						delete Vue.axios.defaults.headers.common['Authorization']
						commit(AUTH_ERROR, err)
						reject(err)
					})
			})
		},
		[AUTH_LOGOUT]: ({ commit, dispatch, state }) => {
			return new Promise((resolve, reject) => {
				Vue.axios({ url: 'authenticate/pro/' + state._id, method: 'DELETE' })
					.then(resp => {
						commit(AUTH_LOGOUT)
						delete Vue.axios.defaults.headers.common['Authorization']
						resolve()
					})
					.catch((err) => {
						commit(AUTH_LOGOUT)
						delete Vue.axios.defaults.headers.common['Authorization']
						reject(err)
					})
			})
		},
		[AUTH_REFRESH]: ({ commit, dispatch, state }) => {
			return new Promise((resolve, reject) => {
				Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.refreshToken
				commit(AUTH_REQUEST)
				Vue.axios({ url: 'authenticate/pro', method: 'PUT' })
					.then(resp => {
						commit(AUTH_SUCCESS, resp.data)

						Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.token

						resolve(resp)
					})
					.catch(err => {
						commit(AUTH_ERROR, err)

						delete Vue.axios.defaults.headers.common['Authorization']

						reject(err)
					})
			})
		}
	},
	mutations: {
		[AUTH_REQUEST]: (state) => {
			state.status = 'loading'
		},
		[AUTH_SUCCESS]: (state, data) => {
			state.status = 'success'
			state.token = data.token
			state.refreshToken = data.refreshToken
			state.tokenExpiration = data.tokenExpiration
			state._id = data._id
			state.user = data.proUser
			localStorage.setItem('user-token', data.token)
			localStorage.setItem('refresh-token', data.refreshToken)
			localStorage.setItem('token-expiration', data.tokenExpiration)
			localStorage.setItem('token-id', data._id)
			localStorage.setItem('user', data.proUser)
		},
		[AUTH_ERROR]: (state) => {
			state.status = 'error'
			localStorage.removeItem('user-token')
			localStorage.removeItem('refresh-token')
			localStorage.removeItem('token-expiration')
			localStorage.removeItem('token-id')
			localStorage.removeItem('user')
		},
		[AUTH_LOGOUT]: (state) => {
			state.status = ''
			state.token = null
			state.refreshToken = null
			state.tokenExpiration = null
			state._id = null
			state.user = null
			localStorage.removeItem('user-token')
			localStorage.removeItem('refresh-token')
			localStorage.removeItem('token-expiration')
			localStorage.removeItem('token-id')
			localStorage.removeItem('user')
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/authentication.js